<template>
	<div class="btn_list">
		<template v-if="groupType === 1">
			<md-button class="md-sm md-success" @click="fistFun(2)">
				<!-- 3> 1 -->
				{{ this.$t("common.enable") }}
				<i class="fa fa-caret-right small_icon" aria-hidden="true"></i>
			</md-button>
			<md-button class="md-sm md-block" @click="secondFun(1)">
				<!-- 1 > 3 -->
				<i class="fa fa-caret-left small_icon" aria-hidden="true"></i>
				{{ this.$t("common.block") }}
			</md-button>
		</template>

		<template v-if="groupType === 2">
			<div class="group-type-2 flex">
				<!-- 2 > 3 -->
				<md-button class="md-sm md-block" @click="secondFun">
					<i class="fa fa-caret-left small_icon" aria-hidden="true"></i>
					{{ this.$t("common.block") }}
				</md-button>

				<!-- 2 > 1 -->
				<md-button class="md-sm md-success" @click="fistFun(1)">
					{{ this.$t("common.enable") }}
					<i class="fa fa-caret-right small_icon" aria-hidden="true"></i>
				</md-button>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	props: {
		groupType: [Number, String],
		fistFun: Function,
		secondFun: Function
	},
	data() {
		return {};
	}
};
</script>

<style lang="scss" scoped>
	.btn_list {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 10px 10px 0;
	}

	.small_icon {
		line-height: 17px;
	}

	.group-type-2 .md-button {
		margin-left: 5px;
		margin-right: 5px;
	}
</style>
